import React from "react";

import numeral from "numeral";

import HeroSection from "components/hero-section";

import type { SiteData } from "../constants";

const StatBlock = ({ label, value }: { label: string; value: string }) => {
  return (
    <div className="flex-1 basis-full text-center space-y-1 bg-white p-4 xs:basis-[calc((1/2_*_100%)_-_1rem)] md:basis-[calc((1/3_*_100%)_-_1rem)] xl:basis-0">
      <dt className="text-amber-500 font-bold text-2xl md:text-3xl">{value}</dt>
      <dd className="text-navy-dark whitespace-nowrap">{label}</dd>
    </div>
  );
};

const Stats = ({ revenueToDate }: { revenueToDate: SiteData["revenueToDate"] }) => (
  <div className="bg-white shadow-lg relative z-10">
    <HeroSection className="py-4 sm:py-4 lg:py-4">
      <HeroSection.Content className="text-sm flex flex-col justify-center gap-x-8 gap-y-4 px-4 lg:px-4 xl:items-center xl:flex-row">
        <dl className="grow flex flex-col xs:flex-row flex-wrap bg-gray-200 gap-px">
          <StatBlock
            label="Solar Transactions Processed"
            value={`$${numeral(revenueToDate).format("0a")}+`.toUpperCase()}
          />
          <StatBlock label="Faster Install Timelines" value="62%" />
          <StatBlock label="Integrated Tools & Apps" value="150+" />
          <StatBlock label="Customer Support Satisfaction" value="97%" />
        </dl>
      </HeroSection.Content>
    </HeroSection>
  </div>
);

export default Stats;
